import React from 'react';
import { Button as AntButton, Spin } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/es/button';

interface CustomButtonProps extends Omit<AntdButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary';
  isLoading?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, CustomButtonProps>(
  ({ variant = 'primary', isLoading = false, children, ...props }, ref) => {
    const type = variant === 'primary' ? 'primary' : 'default';

    return (
      <AntButton
        type={type}
        ref={ref}
        variant="solid"
        shape="round"
        disabled={isLoading}
        {...props}
      >
        {isLoading ? <Spin /> : children}
      </AntButton>
    );
  },
);

Button.displayName = 'Button';

export default Button;
